import { v4 as uuid } from 'uuid';

export type UUID = string;

export const generateRandomId = (): UUID => uuid();

export const createKeyGenerator = () => {
    let key = 0;

    return () => {
        key += 1;

        return key;
    }
}
